<template>
    <div>
        <Table :items="eventsList" :columns="columns" :actions="actions" filterProp="event_action" :loading="loading.events" />

        <Dialog :title="dialogTitle" :show="showDialog" :onClose="onCloseDialog">
            You can copy a param by simply clicking it.
            <div class="list">
                <div v-for="(event, index) in latestEventsList" :key="event.id" v-loading="loading.latestEvents">
                    <h4>Reported at: {{ event.date }}</h4>
                    <ul>
                        <li v-for="param in event.params" :key="param.key">
                            <a @click="onCopy(param.key)">
                                <b>{{ param.key }}</b>
                            </a>: {{ param.value }}
                        </li>
                    </ul>
                    <el-divider v-if="index < latestEvents.length - 1" />
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Table from '@/components/Table';
import Dialog from '@/components/Dialog';
import { eventColumns } from '../constants';
import copy from '@/utils/copy';

export default {
    name: 'events',
    data() {
        return {
            columns: eventColumns,
            actions: [
                { name: 'Copy event name', type: 'success', onClick: (item) => this.onCopy(item.event_action) },
                { name: 'View Latest Events', type: 'primary', onClick: this.openDialog },
            ],
            selectedEvent: null,
            latestEvents: [],
            showDialog: false,
            loadingLatestEvents: false,
        };
    },
    mounted() {
        if (!this.events) {
            this.getEvents();
        }
    },
    components: {
        Table,
        Dialog
    },
    computed: {
        ...mapGetters(['events', 'loading']),
        eventsList() {
            return this.events.map(e => ({ event_action: e }));
        },
        latestEventsList() {
            return this.latestEvents.map(e => ({
                date: e.created_at,
                params: Object.keys(e.params).map(key => ({ key, value: e.params[key] })),
            }));
        },
        dialogTitle() {
            return `Latest events for "${this.selectedEvent?.event_action}"`;
        }
    },
    methods: {
        ...mapActions(['getEvents']),
        ...mapMutations(['setLoading', 'unsetLoading']),
        onCopy(param) {
            copy(param);
            this.$notify.success('Copied!');
        },
        onCloseDialog() {
            this.showDialog = false;
            this.latestEvents = [];
        },
        async openDialog(event) {
            const eventName = event.event_action;
            this.selectedEvent = event;
            this.showDialog = true;
            this.setLoading('latestEvents')
            const { data } = await this.$api.get(`/marketing/events/${eventName}`);
            this.latestEvents = data.results;
            this.unsetLoading('latestEvents');
        },
    },
}
</script>

<style scoped>
.header {
    width: 100%;
    display: flex;
    align-items: center;
    margin: 10px 0;
}

.buttons > * {
    margin-right: 5px;
}

h4 {
    margin-right: 10px;
}

a {
    cursor: pointer;
}

.list {
    max-height: 500px;
    overflow: auto;
}
</style>
